var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 194.86 226.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill-rule:evenodd;}.cls-1{fill:url(#GradientFill_1);}.cls-2{fill:url(#GradientFill_1-2);}.cls-3{fill:#980000;}.cls-4{stroke:#e5e5e5;stroke-miterlimit:22.93;stroke-width:0.03px;fill:url(#GradientFill_2);}.cls-5{fill:#ffcb00;}.cls-6{fill:url(#GradientFill_1-3);}.cls-7{fill:url(#GradientFill_1-4);}.cls-8{fill:url(#GradientFill_1-5);}.cls-9{fill:url(#GradientFill_3);}.cls-10{fill:#700f06;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1",
    x1: 133.35,
    y1: 159.51,
    x2: 59.04,
    y2: 148.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#df5521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a31f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-2",
    x1: 34.23,
    y1: 49.23,
    x2: 72.52,
    y2: 85.76,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2",
    x1: 75.97,
    y1: 142.14,
    x2: 76.15,
    y2: 83.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0e0df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-3",
    x1: 168.81,
    y1: 141.01,
    x2: 168.58,
    y2: 162.32,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-4",
    x1: 157.32,
    y1: 173.68,
    x2: 157.09,
    y2: 194.98,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_1-5",
    x1: 91.75,
    y1: -7.83,
    x2: 125.64,
    y2: 36.74,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_3",
    x1: 135.91,
    y1: 76.67,
    x2: 57.07,
    y2: 208.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#740701"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a31f16"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.54,81.13Zm0,0A81.9,81.9,0,1,1,0,179.73,81.93,81.93,0,0,0,121.7,158a81.72,81.72,0,0,0,11-31.74c.3-2.38.5-4.77.59-7.15v0C133.81,107.9,134,95.44,125.55,81.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M144.48,104.34l-.09.17.09-.17Zm-35.16,32.41-.43.18.43-.18Zm-5.66,2.12-.58.18.58-.18Zm-1.15.36-.72.22.72-.22Zm-1.16.35-.64.18.64-.18Zm-6,1.44-.58.11.58-.11Zm-2.43.43-.62.1.62-.1Zm-.62.1-.64.09-1.2.16h0l-1.22.14h0l-1.23.12-.7.06ZM49.5,134.66l-.53-.27.53.27ZM48.17,134l-.59-.32.59.32Zm-1.51-.84-.72-.41.72.41Zm-2.81-1.68-.83-.53.83.53Zm-1.63-1.06-.61-.41.61.41ZM41,129.55l-.62-.43.62.43Zm-1.62-1.16-.63-.48.63.48Zm-1.15-.88-.64-.5.64.5Zm-1.13-.89c-.39-.32-.78-.63-1.16-1,.38.33.77.64,1.16,1Zm-1.54-1.28-.67-.58.67.58Zm-1.09-1c-.4-.35-.8-.71-1.19-1.08.39.37.79.73,1.19,1.08ZM33,123l-.67-.65L33,123Zm-1-1c-.74-.72-1.47-1.46-2.17-2.22.7.76,1.43,1.5,2.17,2.22Zm-2.42-2.48-.69-.76.69.76Zm-.77-.85c-.46-.52-.91-1-1.35-1.56.44.53.89,1,1.35,1.56Zm-1.54-1.78-.66-.79.66.79Zm-.84-1c-.67-.84-1.33-1.7-2-2.57.64.87,1.31,1.73,2,2.57Zm-2.15-2.81c-.65-.89-1.27-1.79-1.87-2.7.6.91,1.22,1.81,1.87,2.7Zm-2-2.88c-.61-.93-1.2-1.89-1.77-2.86.57,1,1.16,1.93,1.77,2.86Zm-1.87-3c-.19-.31-.37-.63-.55-1,.18.33.36.65.55,1Zm-.61-1.07c-.38-.66-.74-1.34-1.1-2,.36.67.72,1.35,1.1,2Zm-1.1-2A71,71,0,0,1,64.05,2.69V19.13c0-3.44,0-7,0-10.76-10.39,0-29.44,14-32,25.2a16.42,16.42,0,0,0,8.07,18.2c9.51,5.06,24,1.14,24-11,0-6.81,0-13.48,0-20.65v27A22.78,22.78,0,0,0,74.4,66.22,71,71,0,0,0,18.68,104.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.64,65.86a70.64,70.64,0,0,1,43.9,15.27h0c8.41,14.3,8.26,26.76,7.73,38-10.35-48.07-85-42.77-114.6-15.08h0A70.92,70.92,0,0,1,81.64,65.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.44,119.87A70.93,70.93,0,0,1,18.68,104.1h0C48.43,76.26,123.68,71,133.44,119.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M50.94,144a22.16,22.16,0,0,1,21.81,18.29h50a4.27,4.27,0,0,1,4.26,4.26h0a4.26,4.26,0,0,1-4.26,4.26H72.59A22.15,22.15,0,1,1,50.94,144Zm0,7.64a14.51,14.51,0,1,0,14.51,14.51A14.51,14.51,0,0,0,50.94,151.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M168.88,162.4h6a1.22,1.22,0,0,0,.27,0,5.14,5.14,0,0,1-3.15-1.29,4.43,4.43,0,0,1-1.16-2.61s0-16,0-16.12a4.26,4.26,0,1,0-8.52,0l0,15.76a13.44,13.44,0,0,0,.25,2.55A12.79,12.79,0,0,0,168.88,162.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M194.86,166.68a4.27,4.27,0,0,0-4.27-4.27H175.11a1.22,1.22,0,0,1-.27,0h-6a12.79,12.79,0,0,1-6.35-1.7,12.86,12.86,0,0,0,12.57,10.21h14.57l.93,0A4.25,4.25,0,0,0,194.86,166.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M157,170.81h-5.95a1.29,1.29,0,0,0-.28,0A5.09,5.09,0,0,1,154,172.1a4.47,4.47,0,0,1,1.16,2.61s0,16,0,16.12a4.27,4.27,0,0,0,8.53,0l0-15.76a14.14,14.14,0,0,0-.24-2.55A12.84,12.84,0,0,0,157,170.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.07,166.54a4.26,4.26,0,0,0,4.26,4.26c.1,0,15.48,0,15.48,0a1.29,1.29,0,0,1,.28,0H157a12.84,12.84,0,0,1,6.36,1.71,12.87,12.87,0,0,0-12.58-10.21H136.26l-.94,0A4.25,4.25,0,0,0,131.07,166.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M181.31,63.27a15.56,15.56,0,0,0-.9-1.83l.9,1.83ZM177,57.61c-3.62-2.71-8.64-3.69-14.06-3.69H85.82c-12-1-19-6.47-18.92-18.4V1.7c0,8.09,4.44,25.38,24.64,26.33C107.68,28,147.47,21.92,177,57.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M66.9,1.7c47.71-7.09,88.08,7,114.41,61.57C151.5,21.29,108.49,28,91.54,28,71.34,27.08,66.9,9.79,66.9,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.54,81.13a89.18,89.18,0,0,1,21.91,27.23c6,11.39-16.41,40.85-26.74,51.3,7-12.38,11.77-24,12.53-39.57.55-11.51.94-24.27-7.7-39Zm25.25,92.6A81.92,81.92,0,0,1,0,179.73c16.66,13.41,34.65,25.79,84.45,27.88C111.71,208.75,135.91,194.25,150.79,173.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M64,8.37c-10.39,0-29.44,14-32,25.2a16.42,16.42,0,0,0,8.07,18.2c9.51,5.06,24,1.14,24-11C64,30.42,64.07,20.4,64,8.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.6,29.48a4.09,4.09,0,1,0-4.08-4.09A4.1,4.1,0,0,0,53.6,29.48Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.179e3229b027dd74ad35693f371f9e21.svg";
export { ForwardRef as ReactComponent };